import apiClient from "../apiClient";

const resource = "dashboard";

export default {
    getStatistic: () => apiClient.get(`${resource}/statistic`),   
    getNominationEmployeesByYear: () => apiClient.get(`${resource}/NominationEmployeesByYear`),   
    geEmployeesByStatus: () => apiClient.get(`${resource}/EmployeesByStatus`),   
    geEmployeesByContractTypes: () => apiClient.get(`${resource}/EmployeesByContractTypes`),   
};